import { render, staticRenderFns } from "./Canofea.vue?vue&type=template&id=68aca758&scoped=true"
import script from "./Canofea.vue?vue&type=script&lang=js"
export * from "./Canofea.vue?vue&type=script&lang=js"
import style0 from "./Canofea.vue?vue&type=style&index=0&id=68aca758&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68aca758",
  null
  
)

export default component.exports